import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PopupHeader, ScrollableContainer } from '@streamr/tv-ui';
import styled from 'styled-components';
import { Button } from '../Button';
import { HideGlobalScrollbar } from '../shared/HideGlobalScrollbar';
import { AbstractPopup, DismissalReason, } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
export function FormPopup({ children, reject, onSubmit, canSubmit, cancelButtonProps, okButtonProps, title, ...props }) {
    return (_jsxs(FormPopupRoot, { reject: reject, ...props, children: [_jsxs(Form, { onSubmit: (e) => {
                    e.preventDefault();
                    if (canSubmit) {
                        onSubmit?.();
                    }
                }, children: [_jsx(PopupHeader, { onCloseButtonClick: () => {
                            reject(DismissalReason.CloseButton);
                        }, children: title }), _jsx(ScrollableContainer, { children: children }), (okButtonProps || cancelButtonProps) && (_jsxs(Buttons, { children: [cancelButtonProps && (_jsx(Button, { type: "button", size: "mini", kind: "secondary", padding: "small", onClick: cancelButtonProps.onClick, children: cancelButtonProps.label ?? 'Cancel' })), okButtonProps && (_jsxs(_Fragment, { children: [!cancelButtonProps && _jsx("div", {}), _jsx(Button, { type: "submit", size: "mini", kind: "secondary", padding: "small", onClick: okButtonProps.onClick, disabled: !canSubmit, children: okButtonProps.label ?? 'Ok' })] }))] }))] }), _jsx(HideGlobalScrollbar, {})] }));
}
const Buttons = styled.div `
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 1.25rem 1.5rem;
    gap: 1rem;
    border-top: 1px solid #dedede33;

    @media (min-width: 30rem) {
        display: flex;
        justify-content: flex-end;

        button {
            width: 6.5rem;
        }
    }
`;
const Form = styled.form `
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: var(--vh-100, 100vh);

    @media (min-width: 30rem) {
        height: auto;
        max-height: min(40rem, calc(var(--vh-100, 100vh) - 2rem));
    }
`;
const FormPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    --Popup_Padding: 0;
    --PopupHeader_Padding: 1.5rem;

    @media (min-width: 30rem) {
        ${PopupCssPreset.Center};
        --Popup_Width: 28.625rem;
    }
`;
